export const CustomDataKey = Object.freeze({
  HOME_PAGE: "HOME_PAGE"
});
